import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Axios from "axios";

const Success = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = searchParams.get('session_id'); // Get the session ID from the URL
    const [message, setMessage] = useState('Validating your subscription...');
    const [isSuccess, setIsSuccess] = useState(false);
    const { user, loading } = useAuth();
    const [userId, setUserId] = useState(null);   

    useEffect(() => {
        // Extract and set the userId once the user is available
        if (user && user.uid) {
            setUserId(user.uid);
        }
    }, [user]);

    useEffect(() => {
        const validateSubscription = async () => {
            if (!sessionId || !userId) {
                setMessage('Missing required information for subscription validation.');
                setIsSuccess(false);
                return;
            }

            try {
                const planType = localStorage.getItem('planType');

                if (!planType) {
                    setMessage('Plan type is missing. Please try again.');
                    setIsSuccess(false);
                    return;
                }

                // Create a new FormData object
                const formData = new FormData();
                formData.append('request', 'addSubscriptionDetails');
                formData.append('userId', userId);
                formData.append('transactionId', sessionId);
                formData.append('planType', planType);

                const URL = process.env.REACT_APP_BACKENDURL;

                // Send the POST request using Axios
                const response = await Axios.post(URL, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Important for FormData
                    },
                    withCredentials: true, // Include credentials (cookies) if necessary
                });

                if (response.status === 200) {
                    setMessage('Subscription successful! Thank you for subscribing.');
                    setIsSuccess(true);
                } else {
                    setMessage('Subscription validation failed. Please contact support.');
                    setIsSuccess(false);
                }
            } catch (error) {
                console.error('Error validating subscription:', error);
                setMessage('An error occurred while validating your subscription. Please try again.');
                setIsSuccess(false);
            }
        };

        // Only validate the subscription when sessionId and userId are both available
        if (sessionId && userId) {
            validateSubscription();
        }
    }, [sessionId, userId]);

    const handleNavigate = () => {
        navigate(isSuccess ? '/' : '/pricing'); // Navigate to dashboard on success, or pricing on failure
    };

    return (
        <div className="container payment-success text-center py-5" style={{ color: '#EEEEF0' }}>
            <h1>{message}</h1>
            <button className="btn btn-login mt-4" onClick={handleNavigate}>
                {isSuccess ? 'Start Exploring' : 'Return to Pricing'}
            </button>
        </div>
    );
};

export default Success;
